import script from "./GetStartedPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GetStartedPage.vue?vue&type=script&setup=true&lang=ts"

import "./GetStartedPage.vue?vue&type=style&index=0&id=84d37776&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84d37776"]])

export default __exports__